<div fxFlexFill fxLayout="column" fxLayoutAlign="start stretch">
  <h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px;">
    <div fxFlex>Fax Logs</div>
    <button mat-icon-button [mat-dialog-close]="false" class="button-40">
      <mat-icon>close</mat-icon>
    </button>
  </h1>
  <mat-dialog-content class="mat-typography" fxFlex>
    <app-fax-logs-grid [filterChangeEvent]="filterChangeEvent"></app-fax-logs-grid>
  </mat-dialog-content>
</div>





